import { INewsDetailsCarouselModel } from 'models/news-details-model';
import React from 'react';
import { Fade } from 'react-slideshow-image';

import 'react-slideshow-image/dist/styles.css';
import ContentRenderer from '../editorjs/editorjs-renderer';

import styles from './news-carousel.module.scss';

type Props = {
  content: INewsDetailsCarouselModel;
};

const fadeProperties = {
  indicators: true,
  autoplay: false,
};

export default function NewsCarousel({ content }: Props) {
  if (!content) return <></>;

  return (
    <div className={styles.container}>
      {content.description && (
        <div>
          <ContentRenderer content={content.description} />
        </div>
      )}
      <Fade {...fadeProperties}>
        {content.images.map((each, index) => (
          <div
            className={styles['each-slide']}
            key={index}
            onClick={() => console.log('click')}>
            <img
              className={styles['image']}
              src={each.url}
              alt={each.caption}
            />
            {each.caption && each.caption !== each.name && (
              <div>{each.caption}</div>
            )}
          </div>
        ))}
      </Fade>
    </div>
  );
}
